export enum MethodType {
  Get,
  Post,
}
